import React from 'react';
import { Alert } from 'react-bootstrap';

function StatusAlert({ alert, onClose }) {
    if (!alert?.message && !alert?.details?.length) return null;

    return (
        <Alert
            variant={alert.type || 'info'}
            dismissible={alert.dismissible !== false}
            onClose={onClose}
        >
            {alert.title ? <Alert.Heading>{alert.title}</Alert.Heading> : null}

            {alert.message ? <div>{alert.message}</div> : null}

            {Array.isArray(alert.details) && alert.details.length > 0 ? (
                <ul className="mb-0 mt-2">
                    {alert.details.map((item, idx) => (
                        <li key={`${item}-${idx}`}>{item}</li>
                    ))}
                </ul>
            ) : null}
        </Alert>
    );
}

export default StatusAlert;